export const API_PATH = {
  Payment: {
    adminNonPayment: {
      method: 'POST',
      path: '/v1/admin-payment-action/purchase/substitution/nft/register',
    },
    retrieveCard: {
      method: 'POST',
      path: '/v1/payment-actions/card/retrieve',
    },
    createOrderForDropsPurchase: {
      method: 'POST',
      path: '/v1/payment-actions/order/register/drops/purchase',
    },
    createOrderForNftMint: {
      method: 'POST',
      path: '/v1/payment-actions/order/register/nft/mint',
    },
    createOrderForNftPurchase: {
      method: 'POST',
      path: '/v1/payment-actions/order/register/nft/purchase',
    },
    createOrderForConditionalUtility: {
      method: 'POST',
      path: '/v1/payment-actions/order/register/utility/condition',
    },
    createOrderForNfticon: {
      method: 'POST',
      path: '/v1/payment-actions/order/register/utility/nfticon',
    },
    getOrder: {
      method: 'POST',
      path: '/v1/payment-actions/order/{orderId}',
    },
    purchaseFreeItem: {
      method: 'POST',
      path: '/v1/payment-actions/purchase/free',
    },
    purchaseByGempay: {
      method: 'POST',
      path: '/v1/payment-actions/purchase/gempay',
    },
    purchaseByStripe: {
      method: 'POST',
      path: '/v1/payment-actions/purchase/stripe',
    },
    getCurrentExchangeRate: {
      method: 'POST',
      path: '/v1/payment-actions/retrieve/exchange-rate',
    },
    getGasFees: {
      method: 'POST',
      path: '/v1/payment-actions/retrieve/gas-fee',
    },
    computeDropsPrice: {
      method: 'POST',
      path: '/v1/payment-actions/retrieve/price/drops',
    },
    computeNftTotalPrice: {
      method: 'POST',
      path: '/v1/payment-actions/retrieve/price/nft',
    },
    computeNftRegisterFee: {
      method: 'POST',
      path: '/v1/payment-actions/retrieve/price/nft/registration',
    },
    computeConditionUtilityFee: {
      method: 'POST',
      path: '/v1/payment-actions/retrieve/price/utility/condition',
    },
    getNftPrices: {
      method: 'POST',
      path: '/v1/payment-actions/retrieve/price/utility/nfticon',
    },
    saveGasFees: {
      method: 'POST',
      path: '/v1/payment-actions/update/gas-fee',
    },
    handlePortoneWebHook: {
      method: 'POST',
      path: '/v1/payment-webhook/portone',
    },
    confirmPortonePayment: {
      method: 'POST',
      path: '/v1/payment-webhook/portone/confirm',
    },
    handleStripeWebHook: {
      method: 'POST',
      path: '/v1/payment-webhook/stripe',
    },
    getPaymentHistory: {
      method: 'GET',
      path: '/v1/payments/{orderId}',
    },
    getPaymentDetails: {
      method: 'GET',
      path: '/v1/payments/{orderId}/details',
    },
    getPaymentItem: {
      method: 'GET',
      path: '/v1/payments/{orderId}/items',
    },
  },
  SbtDiscountRate: {
    deleteDiscountTemplates: {
      method: 'DELETE',
      path: '/v1/admin/sbt-discount-rates',
    },
    updateDiscountTemplate: {
      method: 'PATCH',
      path: '/v1/admin/sbt-discount-rates',
    },
    registerDiscountTemplate: {
      method: 'POST',
      path: '/v1/admin/sbt-discount-rates',
    },
    findDiscountTemplates: {
      method: 'GET',
      path: '/v1/sbt-discount-rates',
    },
  },
  SbtTemplate: {
    getAllSbtTemplateByOffset: {
      method: 'GET',
      path: '/v1/admin/sbt-templates',
    },
    createSbtTemplate: {
      method: 'POST',
      path: '/v1/admin/sbt-templates',
    },
    deleteSbtTemplate: {
      method: 'DELETE',
      path: '/v1/admin/sbt-templates/{id}',
    },
    updateSbtTemplate: {
      method: 'PATCH',
      path: '/v1/admin/sbt-templates/{id}',
    },
    getAllSbtTemplateByCursor: {
      method: 'GET',
      path: '/v1/sbt-templates',
    },
    getSbtTemplate: {
      method: 'GET',
      path: '/v1/sbt-templates/{id}',
    },
  },
  SBT: {
    provideSbt: {
      method: 'POST',
      path: '/v1/admin/sbts',
    },
    presentSbt: {
      method: 'POST',
      path: '/v1/admin/sbts/present',
    },
    expireSbt: {
      method: 'PATCH',
      path: '/v1/admin/sbts/{sbtId}',
    },
    getAllSbtForIssuer: {
      method: 'GET',
      path: '/v1/admin/users/{userId}/issue-sbts',
    },
    getSbtsStatistics: {
      method: 'GET',
      path: '/v1/admin/users/{userId}/sbt-statistics',
    },
    getAllSbtForTemplateOwner: {
      method: 'GET',
      path: '/v1/admin/users/{userId}/sbts',
    },
    applySbt: {
      method: 'POST',
      path: '/v1/sbt-actions',
    },
    getSbtById: {
      method: 'GET',
      path: '/v1/sbts/{sbtId}',
    },
    getAllSbt: {
      method: 'GET',
      path: '/v1/users/{userId}/sbts',
    },
  },
  PointToken: {
    issueAdditionalPointToken: {
      method: 'POST',
      path: '/v1/point-token-actions/additional-point/issue',
    },
    dropPointToken: {
      method: 'POST',
      path: '/v1/point-token-actions/grant',
    },
    getPointTokensWithUserBalanceByCreatorType: {
      method: 'GET',
      path: '/v1/point-tokens',
    },
    issuePointToken: {
      method: 'POST',
      path: '/v1/point-tokens',
    },
    getPointToken: {
      method: 'GET',
      path: '/v1/point-tokens/{tokenId}',
    },
    updatePointTokenSymbol: {
      method: 'PUT',
      path: '/v1/point-tokens/{tokenId}',
    },
    findUserIssuedPointToken: {
      method: 'GET',
      path: '/v1/users/{userId}/issued-point-tokens',
    },
    getOwnedTokenHistoriesByOffsetPagination: {
      method: 'GET',
      path: '/v1/users/{userId}/point-token-histories/{tokenId}',
    },
    findOwnedUserPointTokens: {
      method: 'GET',
      path: '/v1/users/{userId}/point-tokens',
    },
    findUserPointToken: {
      method: 'GET',
      path: '/v1/users/{userId}/point-tokens/{tokenId}',
    },
    findUserPointTokenHistories: {
      method: 'GET',
      path: '/v1/users/{userId}/point-tokens/{tokenId}/histories',
    },
  },
  PartnerAPI: {
    getUsersSbt_2: {
      method: 'GET',
      path: '/v1/api/pointtokens/getUsersPointTokenBalance',
    },
    retrievePointToken: {
      method: 'POST',
      path: '/v1/api/pointtokens/retrievePointToken',
    },
    givePointToken: {
      method: 'POST',
      path: '/v1/api/pointtokens/transferPointToken',
    },
    getUsersSbt_1: {
      method: 'GET',
      path: '/v1/api/sbts/getUsersSbts',
    },
    giveSbt: {
      method: 'POST',
      path: '/v1/api/sbts/giveSbt',
    },
    getUsersSbt: {
      method: 'GET',
      path: '/v1/api/votes/getVoteResult',
    },
  },
  Badge: {
    getData_1: {
      method: 'GET',
      path: '/v1/car/get-data',
    },
    getData: {
      method: 'GET',
      path: '/v1/link/link-test',
    },
    getAddressList: {
      method: 'GET',
      path: '/v1/realestate/get-address-list',
    },
    getOfficialPrice: {
      method: 'GET',
      path: '/v1/realestate/get-official-price',
    },
    isOwner: {
      method: 'GET',
      path: '/v1/realestate/is-owner',
    },
    getAccessCode: {
      method: 'GET',
      path: '/v1/youtube/get-access-code',
    },
    getSubscriberCount: {
      method: 'GET',
      path: '/v1/youtube/get-subscriber-count',
    },
  },
  Collection: {
    isDuplicateUrl: {
      method: 'GET',
      path: '/v1/collection-actions/find',
    },
    reportCollection: {
      method: 'POST',
      path: '/v1/collection-actions/report',
    },
    registerDrops: {
      method: 'POST',
      path: '/v1/collection-actions/sale/register',
    },
    unRegisterDrops: {
      method: 'POST',
      path: '/v1/collection-actions/sale/unregister',
    },
    validateStatus: {
      method: 'GET',
      path: '/v1/collection-actions/sale/validate/individual',
    },
    findCollections: {
      method: 'GET',
      path: '/v1/collections',
    },
    createCollection: {
      method: 'POST',
      path: '/v1/collections',
    },
    deleteCollection: {
      method: 'DELETE',
      path: '/v1/collections/{collectionId}',
    },
    findCollection: {
      method: 'GET',
      path: '/v1/collections/{collectionId}',
    },
    updateCollection: {
      method: 'PUT',
      path: '/v1/collections/{collectionId}',
    },
    findCollectionDrops: {
      method: 'GET',
      path: '/v1/collections/{collectionId}/drops',
    },
    findCollectionSaleHistories: {
      method: 'GET',
      path: '/v1/collections/{collectionId}/nft/histories',
    },
    registerDownloadUtility: {
      method: 'POST',
      path: '/v1/collections/{collectionId}/nft/utility/downloads',
    },
    registerMobileCoupon: {
      method: 'POST',
      path: '/v1/collections/{collectionId}/nft/utility/mobile-coupons',
    },
    getNfts_1: {
      method: 'GET',
      path: '/v1/collections/{collectionId}/nfts',
    },
    findCollectionPolicy: {
      method: 'GET',
      path: '/v1/collections/{collectionId}/policy',
    },
    findCollectionStatistics: {
      method: 'GET',
      path: '/v1/collections/{collectionId}/statistics',
    },
    findCollectionOwnerHoldings: {
      method: 'GET',
      path: '/v1/collections/{collectionId}/statistics/ownerholdings',
    },
  },
  Curation: {
    hideBannerCuration: {
      method: 'POST',
      path: '/v1/curation-actions/banner/hide',
    },
    changeOrderBannerCuration: {
      method: 'POST',
      path: '/v1/curation-actions/banner/order/change',
    },
    randomOrderBannerCuration: {
      method: 'POST',
      path: '/v1/curation-actions/banner/order/random',
    },
    hideCollectionCuration: {
      method: 'POST',
      path: '/v1/curation-actions/collection/hide',
    },
    changeOrderCollectionCuration: {
      method: 'POST',
      path: '/v1/curation-actions/collection/order/change',
    },
    randomOrderCollectionCuration: {
      method: 'POST',
      path: '/v1/curation-actions/collection/order/random',
    },
    hideCreatorCuration: {
      method: 'POST',
      path: '/v1/curation-actions/creator/hide',
    },
    changeOrderCreatorCuration: {
      method: 'POST',
      path: '/v1/curation-actions/creator/order/change',
    },
    randomOrderCreatorCuration: {
      method: 'POST',
      path: '/v1/curation-actions/creator/order/random',
    },
    hideHistoryCuration: {
      method: 'POST',
      path: '/v1/curation-actions/histories/hide',
    },
    changeOrderHistoryCuration: {
      method: 'POST',
      path: '/v1/curation-actions/histories/order/change',
    },
    randomOrderHistoryCuration: {
      method: 'POST',
      path: '/v1/curation-actions/histories/order/random',
    },
    getBannerCurationItem: {
      method: 'GET',
      path: '/v1/curation/banners',
    },
    addBannerCurationItem: {
      method: 'POST',
      path: '/v1/curation/banners',
    },
    deleteBannerCurationItem: {
      method: 'DELETE',
      path: '/v1/curation/banners/{curationId}',
    },
    updateBannerCurationItem: {
      method: 'PATCH',
      path: '/v1/curation/banners/{curationId}',
    },
    getCollectionCurationItem: {
      method: 'GET',
      path: '/v1/curation/collections',
    },
    addCollectionCurationItem: {
      method: 'POST',
      path: '/v1/curation/collections',
    },
    deleteCollectionCurationItem: {
      method: 'DELETE',
      path: '/v1/curation/collections/{curationId}',
    },
    getCreatorCurationItem: {
      method: 'GET',
      path: '/v1/curation/creators',
    },
    addCreatorCurationItem: {
      method: 'POST',
      path: '/v1/curation/creators',
    },
    deleteCreatorCurationItem: {
      method: 'DELETE',
      path: '/v1/curation/creators/{curationId}',
    },
    getHistoryCurationItem: {
      method: 'GET',
      path: '/v1/curation/histories',
    },
    addHistoryCurationItem: {
      method: 'POST',
      path: '/v1/curation/histories',
    },
    deleteHistoryCurationItem: {
      method: 'DELETE',
      path: '/v1/curation/histories/{curationId}',
    },
    updateHistoryCurationItem: {
      method: 'PATCH',
      path: '/v1/curation/histories/{curationId}',
    },
    getTradeCurationItem: {
      method: 'GET',
      path: '/v1/curation/trades',
    },
  },
  LinkPage: {
    addUserLinkPages: {
      method: 'POST',
      path: '/v1/linkpages/',
    },
    deleteUserLinkPages: {
      method: 'DELETE',
      path: '/v1/linkpages/{linkPageId}',
    },
    getUserLinkPages: {
      method: 'GET',
      path: '/v1/linkpages/{linkPageId}',
    },
    updateUserLinkPages: {
      method: 'PATCH',
      path: '/v1/linkpages/{linkPageId}',
    },
  },
  Migration: {
    migrateNftByNftId: {
      method: 'POST',
      path: '/v1/migration-actions/migrate/nft-by-nft-id',
    },
    migrateNftByPageId: {
      method: 'POST',
      path: '/v1/migration-actions/migrate/nft-by-page-id',
    },
    migrateUser: {
      method: 'POST',
      path: '/v1/migration-actions/migrate/user',
    },
  },
  MobileCouponProduct: {
    deleteMobileCouponProduct: {
      method: 'DELETE',
      path: '/v1/mobile-coupon-products',
    },
    findMobileCouponProductOfAffiliate: {
      method: 'GET',
      path: '/v1/mobile-coupon-products',
    },
    updateMobileCouponProduct: {
      method: 'PATCH',
      path: '/v1/mobile-coupon-products',
    },
    saveMobileCouponProduct: {
      method: 'POST',
      path: '/v1/mobile-coupon-products',
    },
    findMobileCouponProduct: {
      method: 'GET',
      path: '/v1/mobile-coupon-products/{id}',
    },
  },
  NFT: {
    airdropNft: {
      method: 'POST',
      path: '/v1/nft-actions/airdrop',
    },
    downloadNft: {
      method: 'POST',
      path: '/v1/nft-actions/download',
    },
    validateNftDownloadable: {
      method: 'POST',
      path: '/v1/nft-actions/download/validate',
    },
    hideNft: {
      method: 'POST',
      path: '/v1/nft-actions/hide',
    },
    likeNft: {
      method: 'POST',
      path: '/v1/nft-actions/like',
    },
    presentNft: {
      method: 'POST',
      path: '/v1/nft-actions/present',
    },
    presentMultiNft: {
      method: 'POST',
      path: '/v1/nft-actions/present-multi',
    },
    cancelSendingNft: {
      method: 'POST',
      path: '/v1/nft-actions/present/cancel',
    },
    receivePresentNft: {
      method: 'POST',
      path: '/v1/nft-actions/present/receive',
    },
    reportNft: {
      method: 'POST',
      path: '/v1/nft-actions/report',
    },
    registerSales: {
      method: 'POST',
      path: '/v1/nft-actions/sale/register',
    },
    unregisterSales: {
      method: 'POST',
      path: '/v1/nft-actions/sale/unregister',
    },
    obtainStatus: {
      method: 'POST',
      path: '/v1/nft-actions/status/obtain',
    },
    getNfts: {
      method: 'GET',
      path: '/v1/nfts',
    },
    deleteNft: {
      method: 'DELETE',
      path: '/v1/nfts/{nftId}',
    },
    getNftDetail: {
      method: 'GET',
      path: '/v1/nfts/{nftId}',
    },
    updateNft: {
      method: 'PUT',
      path: '/v1/nfts/{nftId}',
    },
    getNftHistories: {
      method: 'GET',
      path: '/v1/nfts/{nftId}/histories',
    },
    getNftStatistics: {
      method: 'GET',
      path: '/v1/nfts/{nftId}/statistics',
    },
  },
  Partner: {
    createPartner: {
      method: 'POST',
      path: '/v1/partners',
    },
    deletePartner: {
      method: 'DELETE',
      path: '/v1/partners/{partnerId}',
    },
    getPartner: {
      method: 'GET',
      path: '/v1/partners/{partnerId}',
    },
    updatePartner: {
      method: 'PATCH',
      path: '/v1/partners/{partnerId}',
    },
  },
  Relation: {
    acceptAuthorizingRequest: {
      method: 'POST',
      path: '/v1/relation-actions/authorization/accept',
    },
    requestAuthorization: {
      method: 'POST',
      path: '/v1/relation-actions/authorization/request',
    },
    validateAuthorization: {
      method: 'GET',
      path: '/v1/relation-actions/authorization/validate',
    },
    validateBadgeRequestExist: {
      method: 'POST',
      path: '/v1/relation-actions/badges/request/validate',
    },
    requestBadge: {
      method: 'POST',
      path: '/v1/relation/badges',
    },
    getGuarantor: {
      method: 'GET',
      path: '/v1/relation/guarantors',
    },
  },
  DAO: {
    findAll_1: {
      method: 'GET',
      path: '/v1/spaces',
    },
    createSpace: {
      method: 'POST',
      path: '/v1/spaces',
    },
    updateSpace: {
      method: 'POST',
      path: '/v1/spaces/{spaceId}',
    },
    findVoteParticipations: {
      method: 'GET',
      path: '/v1/spaces/{spaceId}/vote-participations',
    },
    findVoteStatistics: {
      method: 'GET',
      path: '/v1/spaces/{spaceId}/vote-statistics',
    },
    findVotes: {
      method: 'GET',
      path: '/v1/spaces/{spaceId}/votes',
    },
    findJoinedSpaceByUserId: {
      method: 'GET',
      path: '/v1/users/{userId}/joined-spaces',
    },
    findJoinedSpaceVoteByUserId: {
      method: 'GET',
      path: '/v1/users/{userId}/joined-spaces/votes',
    },
    findCreatedSpaceByUserId: {
      method: 'GET',
      path: '/v1/users/{userId}/space',
    },
    checkDeletableVote: {
      method: 'GET',
      path: '/v1/vote-actions/deletable',
    },
    participateVote: {
      method: 'POST',
      path: '/v1/vote-actions/participate',
    },
    getVotableAmount: {
      method: 'GET',
      path: '/v1/vote-actions/votable-amount',
    },
    findAll: {
      method: 'GET',
      path: '/v1/votes',
    },
    createVote: {
      method: 'POST',
      path: '/v1/votes',
    },
    deleteVote: {
      method: 'DELETE',
      path: '/v1/votes/{voteId}',
    },
    findVoteById: {
      method: 'GET',
      path: '/v1/votes/{voteId}',
    },
    findProgressById: {
      method: 'GET',
      path: '/v1/votes/{voteId}/participations',
    },
    findStatisticsById: {
      method: 'GET',
      path: '/v1/votes/{voteId}/statistics',
    },
  },
  Token: {
    createJwtToken: {
      method: 'GET',
      path: '/v1/token/token-test-create-jwt-token',
    },
    noPermissionTest: {
      method: 'GET',
      path: '/v1/token/token-test-noPermissionTest',
    },
    renewAccessToken_1: {
      method: 'GET',
      path: '/v1/token/token-test-renew-access-token',
    },
    requestAttributeTest: {
      method: 'GET',
      path: '/v1/token/token-test-requestAttribute',
    },
    validateJwtToken: {
      method: 'GET',
      path: '/v1/token/token-test-validate-token',
    },
  },
  User: {
    registerCardToCustomer: {
      method: 'POST',
      path: '/v1/user-actions/card/register',
    },
    getUserByUrl: {
      method: 'GET',
      path: '/v1/user-actions/find',
    },
    grantPartner: {
      method: 'POST',
      path: '/v1/user-actions/partner/grant',
    },
    signOAuth: {
      method: 'POST',
      path: '/v1/user-actions/sign/oauth',
    },
    renewAccessToken: {
      method: 'POST',
      path: '/v1/user-actions/token/renew',
    },
    updateVerificationData: {
      method: 'POST',
      path: '/v1/user-actions/update/verification',
    },
    verifyUserPhone: {
      method: 'POST',
      path: '/v1/user-actions/verify/phone',
    },
    getAllUser: {
      method: 'GET',
      path: '/v1/users/',
    },
    createUser: {
      method: 'POST',
      path: '/v1/users/',
    },
    addAdminPartners: {
      method: 'POST',
      path: '/v1/users/admin-partner',
    },
    createAptosWalletToUsers: {
      method: 'POST',
      path: '/v1/users/test/create/aptos',
    },
    addUserPartners: {
      method: 'POST',
      path: '/v1/users/user-partner',
    },
    deleteUser: {
      method: 'DELETE',
      path: '/v1/users/{userId}/',
    },
    getUser: {
      method: 'GET',
      path: '/v1/users/{userId}/',
    },
    updateUser: {
      method: 'PATCH',
      path: '/v1/users/{userId}/',
    },
    deleteBankAccount: {
      method: 'DELETE',
      path: '/v1/users/{userId}/bank-account',
    },
    getBankAccount: {
      method: 'GET',
      path: '/v1/users/{userId}/bank-account',
    },
    updateBankAccount: {
      method: 'PATCH',
      path: '/v1/users/{userId}/bank-account',
    },
    addBankAccount: {
      method: 'POST',
      path: '/v1/users/{userId}/bank-account',
    },
    updateBankAccountOpenStatusByAdmin: {
      method: 'PATCH',
      path: '/v1/users/{userId}/bank-account/admin',
    },
    getUserCollections: {
      method: 'GET',
      path: '/v1/users/{userId}/collections',
    },
    getUserLikeNft: {
      method: 'GET',
      path: '/v1/users/{userId}/liked-nfts',
    },
    findLinkedUsers: {
      method: 'GET',
      path: '/v1/users/{userId}/linked-users',
    },
    findLinkedUser: {
      method: 'GET',
      path: '/v1/users/{userId}/linked-users/{linkedUserId}',
    },
    getMetaMask: {
      method: 'GET',
      path: '/v1/users/{userId}/meta-masks',
    },
    addMetaMask: {
      method: 'POST',
      path: '/v1/users/{userId}/meta-masks/',
    },
    deleteMetaMask: {
      method: 'DELETE',
      path: '/v1/users/{userId}/meta-masks/{metaMaskId}',
    },
    updateMetaMask: {
      method: 'PATCH',
      path: '/v1/users/{userId}/meta-masks/{metaMaskId}',
    },
    getUserCollectNfts: {
      method: 'GET',
      path: '/v1/users/{userId}/nft/collects',
    },
    getUserHideNfts: {
      method: 'GET',
      path: '/v1/users/{userId}/nft/hides',
    },
    getUserMintNfts: {
      method: 'GET',
      path: '/v1/users/{userId}/nft/mints',
    },
    getUserNfticonNfts: {
      method: 'GET',
      path: '/v1/users/{userId}/nft/nfticons',
    },
    registerCreditCard: {
      method: 'POST',
      path: '/v1/users/{userId}/paymentIds',
    },
    deleteCard: {
      method: 'DELETE',
      path: '/v1/users/{userId}/paymentIds/stripeCardId',
    },
    getUserPrivacy: {
      method: 'GET',
      path: '/v1/users/{userId}/privacy',
    },
    getRole: {
      method: 'GET',
      path: '/v1/users/{userId}/roles',
    },
    createRole: {
      method: 'POST',
      path: '/v1/users/{userId}/roles',
    },
    deleteRole: {
      method: 'DELETE',
      path: '/v1/users/{userId}/roles/{role}',
    },
    getSettlementHistories: {
      method: 'GET',
      path: '/v1/users/{userId}/settlement-histories',
    },
    settlementRequest: {
      method: 'POST',
      path: '/v1/users/{userId}/settlement-request',
    },
    getUserUsageInfo: {
      method: 'GET',
      path: '/v1/users/{userId}/usages',
    },
    getAllWalletList: {
      method: 'GET',
      path: '/v1/users/{userId}/wallets',
    },
    addWallet: {
      method: 'POST',
      path: '/v1/users/{userId}/wallets',
    },
    deleteWallet: {
      method: 'DELETE',
      path: '/v1/users/{userId}/wallets/{walletId}',
    },
    getWalletList: {
      method: 'GET',
      path: '/v1/users/{userId}/wallets/{walletId}',
    },
  },
  Util: {
    getNotionData: {
      method: 'POST',
      path: '/v1/util/notion',
    },
    createPresignedUrl: {
      method: 'POST',
      path: '/v1/util/r2/presign',
    },
    createShortUrlUsingYourls: {
      method: 'POST',
      path: '/v1/util/shorturl',
    },
  },
};
